// extracted by mini-css-extract-plugin
export default {"invalid":"ClienteEdit_invalid__NzCG3","spinnerContainer":"ClienteEdit_spinnerContainer__Tohfd"};